export default "__VITE_ASSET__xRakOJnh__"